<script>
import Layout from "../../layouts/main";
import OrdersApi from "@/services/orders-api";
import OrdersComponent from "../../../components/ordersComponent.vue";


export default {
  page: {
    title: "Bannières",
  },
  components: {
    Layout, OrdersComponent
  },

  methods: {
    countOrders(){
        OrdersApi.getOrdersCount(null).then(
            (result)=>{
                if(result){
                    this.ordersCount=result
                }else{
                    this.ordersCount=0

                }
            }
        )
    },
   
    },
  };


</script>

<template>
    <Layout>
      <div class="row p-sm-4">
        <div class="col-lg-12">
          <div class="card shadow-sm border-0 rounded-3" >
            <div class="card-body p-4">
              <div class="row align-items-center mb-3">
                <div class="col-md-6 col-sm-12">
                  <h2 class="card-title text-primary text-uppercase fw-bold mb-0" style="font-size:25px;">
                    {{ $t('ordersMenu.bigTitle') }}
                  </h2>
                </div>
              </div>

              <ordersComponent />
            </div>
          </div>
        </div>
      </div>

    </Layout>
</template>
